/**
 * The portal's page frame. Scopes every portal style under `.pp-root`, caps the
 * column so a tablet does not stretch a phone layout across 1200px, and swaps
 * the document head over to the portal's PWA identity.
 *
 *   dark   the dark screens: enrolment and the gate
 *   wide   no phone-column cap — the Operator Admin is a desktop tool
 *   title  the browser tab's title (the driver app's, unless a screen says)
 *   installAtThisUrl  no manifest linked, so an iPhone's "Add to Home Screen"
 *          opens the icon at this very URL (the iPhone enrolment screen; the
 *          reason is in usePortalChrome)
 *
 * Note what is NOT here: the dashboard's Header, ChatWidget, Footer or
 * Bootstrap container. The portal is its own surface.
 */
import React, { useRef } from 'react';
import usePortalChrome from '../usePortalChrome';
import { PortalRootContext } from './PortalModal';
import '../Portal.scss';

export default function PortalShell({
  dark = false, wide = false, title, installAtThisUrl = false, children,
}) {
  usePortalChrome(title, { installAtThisUrl });
  // Dialogs mount here (PortalModal), inside the design tokens.
  const root = useRef(null);

  const rootClass = ['pp-root', dark ? 'pp-root--dark' : ''].filter(Boolean).join(' ');
  const shellClass = ['pp-shell', wide ? 'pp-shell--wide' : ''].filter(Boolean).join(' ');

  return (
    <PortalRootContext.Provider value={root}>
      <div ref={root} className={rootClass}>
        <div className={shellClass}>{children}</div>
      </div>
    </PortalRootContext.Provider>
  );
}
